var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
import React from "react";
import classnames from "classnames";
import { Heading, Link } from "@riseart/common";
import { Card } from "../card/Card";
import { CardContent } from "../card/content/Content";
import { CardMedia } from "../card/media/CardMedia";
import { contentCardCls, contentCardTypeInsetCls, contentCardTitleCls } from "./Simple.less";
var TYPE_TO_CLASSNAME = {
  inset: contentCardTypeInsetCls
};
function CardSimple(_ref) {
  var type = _ref.type, title = _ref.title, _ref$link = _ref.link, link = _ref$link === void 0 ? null : _ref$link, _ref$headingProps = _ref.headingProps, headingProps = _ref$headingProps === void 0 ? null : _ref$headingProps, className = _ref.className, children = _ref.children;
  return /* @__PURE__ */ React.createElement(Card, {
    className: classnames(contentCardCls, type && TYPE_TO_CLASSNAME[type], className)
  }, children && /* @__PURE__ */ React.createElement(CardMedia, null, /* @__PURE__ */ React.createElement(Link, _extends({
    type: "strong",
    title
  }, link), children)), title && /* @__PURE__ */ React.createElement(CardContent, {
    className: contentCardTitleCls
  }, /* @__PURE__ */ React.createElement(Heading, _extends({
    tag: "h3",
    align: "center"
  }, headingProps), /* @__PURE__ */ React.createElement(Link, _extends({
    title
  }, link), title))));
}
__name(CardSimple, "CardSimple");
export {
  CardSimple
};
